import { Skeleton } from "@/components/ui/skeleton";
import HeaderDataCount from "@/components/views/common/HeaderDataCount";
import EventClientSection from "@/components/views/events/infinite-scroll/EventClientSection";

interface Props extends SearchProps {
  events: any;
}

export default function EventsSection(props: Props) {
  const events = props.events;

  return (
    <div>
      <HeaderDataCount count={events.summary} />

      <EventClientSection {...props} data={events} />
    </div>
  );
}

export function EventLoading() {
  return (
    <div
      id="event-card-skeleton"
      className="grid justify-items-center grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-5 gap-x-4"
    >
      {[...Array(6)].map((_, index) => (
        <Skeleton
          key={index}
          className="custom-animate-pulse w-full lg:w-[386px] h-[217px] rounded-4xl"
        />
      ))}
    </div>
  );
}
